import type { IspSportsAlias } from '@ps/web-core-store';
import { Link } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { Icon } from '@swf/sports/components';
import { EventTypeId } from '@swf/sports/types/eventType';

import { TXTWCL_breadcrumb } from './SportsBreadcrumbsWidget.messages.json';
import styles from './SportsBreadcrumbsWidget.scss';
import { sportsBreadcrumbsWidgetModel, useSportsBreadcrumbsWidget } from './model';

const ALIAS_MAP: Partial<Record<IspSportsAlias, IspSportsAlias>> = {
  sportsPromotion: 'sportsPromotions',
  sportsHistoricalBets: 'sportsMyBets',
  sportsSelfExcludedHistoricalBets: 'sportsSelfExcludedMyBets',
  sportsAnimalRacingRace: 'sportsAnimalRacingMeetings',
  sportsAnimalRacingFutureMarket: 'sportsAnimalRacingFuture',
  sportsCompetitionOutrights: 'sportsSport',
  sportsCompetition: 'sportsSport',
  sportsGolfMatches: 'sportsSport',
  sportsEvent: 'sportsCompetition'
};

const SportsBreadcrumbsWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsBreadcrumbsWidget();
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const errorCode = useSelector(widgetSelect.errorCode);
  const breadcrumb = useSelector(widgetSelect.breadcrumb);
  const { formatMessage } = useRegulatoryIntl();
  const urlParams = useSelector(select.sports.getUrlParams);
  const matchingPathnameAlias = useSelector(select.sports.matchPathnameAlias);

  const alias = matchingPathnameAlias ? ALIAS_MAP[matchingPathnameAlias] : undefined;

  if ((isLoading && !hasPreloaded) || !breadcrumb || errorCode) return null;

  if (matchingPathnameAlias === 'sportsGolfMatches') {
    urlParams.eventTypeId = String(EventTypeId.GOLF);
  }

  return (
    <nav
      className={styles.widget}
      data-testid="sports-breadcrumbs-widget"
      aria-label={formatMessage(TXTWCL_breadcrumb)}
    >
      <Link alias={alias} values={urlParams} className={styles.link}>
        <Icon name="chevron-medium-right" className={styles.arrow} />
        {'text' in breadcrumb ? breadcrumb.text : formatMessage(breadcrumb)}
      </Link>
    </nav>
  );
};

SportsBreadcrumbsWidget.model = sportsBreadcrumbsWidgetModel;

export default withWidgetTestId(SportsBreadcrumbsWidget, 'sports-breadcrumbs');
